<template>
  <div class="hasBeenStoredDetail">
    <div v-if="tableData.length > 0">
      <div class="title" v-if="content">
        {{ content.CountryName }} - {{ content.CargoCategory }}
      </div>
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-header">
          <div class="list-header-text">
            {{ $t.onlineOrder.customerNumber }}：{{ item.CustomerNumber }}
          </div>
          <div class="list-header-text">
            {{ $t.onlineOrder.customerName }}：{{ item.CustomerName }}
          </div>
          <div class="list-header-text">
            {{ $t.onlineOrder.receiveCustomer }}：{{ item.ReceivingName }}
          </div>
          <div class="list-header-text">
            {{ $t.onlineOrder.receivePhone }}：{{ item.PhoneNumber }}
          </div>
          <div class="list-header-text">
            {{ $t.onlineOrder.receiveAddress }}：{{ item.ReceivingAddress }}
          </div>
        </div>
        <div class="list-content" v-for="(product, idx) in item.cusOrderList" :key="idx">
          <van-checkbox
            v-model="product.Checked"
            @click="handleSelectionChange(product, index, idx)"
          ></van-checkbox>
          <div class="left">
            <div class="list-item">
              {{ $t.onlineOrder.postNumber }}：{{ product.ExpressNumber }}
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.goodsName }}：{{ product.CargoName }}
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.cargoQuantity }}：{{ product.CargoQuantity }}
              {{ product.QuantityUnit }}
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.goodsValue }}：{{ product.GoodsValue }}
              {{ product.Currency }}
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.numberPackages }}：{{ product.NumberPackages }}
            </div>
            <div class="list-item">{{ $t.onlineOrder.volume }}：{{ product.Volume }}</div>
            <div class="list-item">{{ $t.onlineOrder.weight }}：{{ product.Weight }}</div>
            <div class="list-item">
              {{ $t.onlineOrder.storageTime }}：{{ product.StorageTime }}
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.isUnpack }}：
              <van-icon name="success" v-if="product.IsUnpack" />
            </div>
            <div class="list-item">
              {{ $t.onlineOrder.taxFeebearingParty }}：
              <span v-if="product.TaxFeebearingParty == 1">{{
                $t.onlineOrder.shipperSn
              }}</span>
              <span v-if="product.TaxFeebearingParty == 2">{{
                $t.onlineOrder.consigneeSn
              }}</span>
            </div>
          </div>
          <div class="right">
            <div class="images">
              <van-image
                width="88"
                height="88"
                fit="cover"
                @click="imagePreview(product.ProductPictureList)"
                :src="imgUrlFilter(product.ProductPictureList[0])"
                v-if="product.ProductPictureList && product.ProductPictureList.length > 0"
              />
              <span v-else>{{ $t.onlineOrder.noImage }}</span>
            </div>
          </div>
        </div>
        <div class="list-footer">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogBillingShow(item.coidlist, item.cusOrderList)"
            >{{ $t.onlineOrder.generateExpress }}</van-button
          >
        </div>
      </div>
    </div>
    <div v-else class="empty-text">{{ $t.meta.noData }}</div>

    <van-dialog
      :title="getDialogTitle()"
      width="90%"
      v-model="dialogBillingVisible"
      @cancel="dialogCancel"
      @confirm="dialogSubmit"
      :cancel-button-text="getDialogCancelText()"
      :confirm-button-text="getDialogConfirmText()"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div
          class="billing-alert"
          :style="{ height: dialogBillingStep == 1 ? 'auto' : '100vw' }"
        >
          <van-form label-width="100px" v-if="dialogBillingStep == 1">
            <van-field
              v-model="dialogBillingForm.Length"
              :label="$t.onlineOrder.length + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.Width"
              :label="$t.onlineOrder.width + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.Height"
              :label="$t.onlineOrder.height + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.WeightKG"
              :label="$t.onlineOrder.weight + ' ( KG )'"
              :placeholder="$t.meta.input"
            />
          </van-form>
          <div class="dialog-container" v-if="dialogBillingStep == 2">
            <div
              class="dialog-table"
              v-for="(item, index) in dialogBillingData"
              :key="index"
            >
              <van-collapse v-model="activeNames">
                <van-collapse-item :name="index">
                  <template #title>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.cargoCategorySn }}：{{
                        item.CountryCargoCategory
                      }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.firstWeightSn }}：
                      <span
                        >{{ item.FirstWeight }} <span v-if="item.WeightUnit == 1">KG</span
                        ><span v-if="item.WeightUnit == 2">cbm</span></span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.firstWeightPrice }}：{{ item.CurrencySymbol }}
                      {{ item.FirstWeightPrice }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.continueWeightSn }}：
                      <span
                        >{{ item.ContinuousWeight }}
                        <span v-if="item.WeightUnit == 1">KG</span
                        ><span v-if="item.WeightUnit == 2">cbm</span></span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.continuePrice }}：{{ item.CurrencySymbol }}
                      {{ item.ContinuousWeightPrice }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.totalFreight }}：<span style="color: red"
                        >{{ item.CurrencySymbol }} {{ item.TotalFreight }}</span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.taxTotal }}：{{ item.CurrencySymbol }}
                      {{ item.TotalTax }}
                    </div>
                  </template>

                  <van-row
                    class="dialog-item-row"
                    v-for="(text, idx) in item.FreightCalculationDetailedExplanationList"
                    :key="idx"
                  >
                    <van-col span="24">{{ text }}</van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
              <div class="dialog-table-footer" v-if="item.TotalTax">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="showCalculate(item.TaxResultList)"
                  >{{ $t.onlineOrder.taxStep }}</van-button
                >
              </div>
            </div>
          </div>
          <van-form label-width="120px" v-if="dialogBillingStep == 3">
            <van-field
              v-model="dialogBillingForm.declaredValue"
              :label="$t.onlineOrder.declareValue"
              disabled
            />

            <van-field
              v-model="dialogBillingForm.declaredValueCurrency"
              :label="$t.onlineOrder.declareValueCurrency"
              disabled
            />

            <van-field
              v-model="dialogBillingForm.deliveryZipCode"
              :label="$t.onlineOrder.deliveryZipCode"
              :placeholder="$t.meta.input"
              required
            />

            <!-- Naqel -->
            <div v-if="content.LogisticsChannel == 1">
              <div class="custom-date">
                <div class="date-btn1">
                  <div class="date-require">*</div>
                  {{ $t.onlineOrder.naqel_ShippingDateTime }}
                </div>
                <div class="date-btn2" @click="showDialogTimeDate">
                  <span v-if="dialogBillingForm.Naqel_ShippingDateTime" class="value">{{
                    dialogBillingForm.Naqel_ShippingDateTime
                  }}</span>
                  <span v-else class="placeholder">{{ $t.meta.select }}</span>
                </div>
              </div>

              <van-field
                v-model="dialogBillingForm.Naqel_DescriptionOfGoods"
                :label="$t.onlineOrder.naqel_DescriptionOfGoods"
                :placeholder="$t.meta.input"
                required
              />

              <van-field
                v-model="dialogBillingForm.Naqel_NumberOfPieces"
                :label="$t.onlineOrder.naqel_NumberOfPieces"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />
            </div>

            <!-- iMile -->
            <div v-if="content.LogisticsChannel == 2">
              <van-field
                v-model="dialogBillingForm.iMile_PackageTotalVolume"
                :label="$t.onlineOrder.iMile_PackageTotalVolume + ' ( cm3 )'"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageGrossWeight"
                :label="$t.onlineOrder.iMile_PackageGrossWeight + ' ( kg )'"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageTotalCount"
                :label="$t.onlineOrder.iMile_PackageTotalCount"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageGoodsType"
                :label="$t.onlineOrder.iMile_PackageGoodsType"
                @click="showGoodsTypePicker = true"
                :placeholder="$t.meta.select"
                clickable
                readonly
                required
              />
            </div>

            <div class="multi-table" v-if="dialogBillingForm.items">
              <div class="custom-field">
                <div class="custom-field-label">{{ $t.onlineOrder.itemsTitle }}</div>
              </div>
              <div v-for="(item, index) in dialogBillingForm.items" :key="index">
                <div class="multi-table-header">
                  <div class="multi-table-title">No.{{ index + 1 }}</div>
                </div>
                <van-field
                  v-model="item.ExpressNumber"
                  :label="$t.onlineOrder.postNumber"
                  disabled
                />
                <van-field
                  v-model="item.CargoName"
                  :label="$t.onlineOrder.goodsName"
                  disabled
                />
                <van-field
                  v-model="item.ItemPrice"
                  :label="$t.onlineOrder.declareValue"
                  :placeholder="$t.meta.input"
                  required
                  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                  @change="getDeclaredValue"
                />
                <van-field
                  v-model="item.Currency"
                  :label="$t.onlineOrder.customsCurrency"
                  :placeholder="$t.meta.input"
                  required
                  @change="getDeclaredValueCurrency"
                />
                <van-field
                  v-model="item.CustomsCode"
                  :label="$t.onlineOrder.hsCode"
                  :placeholder="$t.meta.input"
                  required
                />
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showDialogTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="$t.onlineOrder.naqel_ShippingDateTime"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showDialogTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showGoodsTypePicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.iMile_PackageGoodsType"
        show-toolbar
        :columns="packageGoodsTypeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="typeConfirm"
        @cancel="showGoodsTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Button,
  Icon,
  Image,
  Checkbox,
  Form,
  Field,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Popup,
  DatetimePicker,
  Stepper,
} from "vant";

Vue.use(Button)
  .use(Icon)
  .use(Image)
  .use(Checkbox)
  .use(Form)
  .use(Field)
  .use(Row)
  .use(Col)
  .use(Collapse)
  .use(CollapseItem)
  .use(Popup)
  .use(DatetimePicker)
  .use(Stepper);

export default {
  name: "hasBeenStoredDetail",
  data() {
    return {
      FPId: "",
      FPDId: "",
      content: {},
      tableData: [],
      coidlist: [],
      //日期
      selectDate: new Date(),
      currentDate: "",
      //出境启运-输入计费信息
      dialogBillingData: [],
      dialogBillingVisible: false,
      dialogBillingStep: 1,
      dialogBillingForm: {
        Length: null,
        Width: null,
        Height: null,
        WeightKG: null,
        declaredValue: null,
        declaredValueCurrency: null,
        deliveryZipCode: "",
        //Naqel
        Naqel_ShippingDateTime: "",
        Naqel_DescriptionOfGoods: "",
        Naqel_NumberOfPieces: null,
        //iMile
        iMile_PackageTotalVolume: null,
        iMile_PackageGrossWeight: null,
        iMile_PackageTotalCount: null,
        iMile_PackageGoodsType: "",
        items: [],
        detailList: [],
      },
      activeNames: [],
      showDialogTimePicker: false,
      showGoodsTypePicker: false,
      packageGoodsTypeList: ["Normal", "Sensitive", "Battery", "PureBattery"],
    };
  },
  created() {
    const { FPId, FPDId } = this.$route.query;
    this.FPId = FPId;
    this.FPDId = FPDId;
    this.getCustomerOrderAlreadyInStorageListByTransportService();
  },
  methods: {
    typeConfirm(val) {
      if (!val) {
        return;
      }
      this.dialogBillingForm.iMile_PackageGoodsType = val;
      this.showGoodsTypePicker = false;
    },
    getDialogConfirmText() {
      if (this.dialogBillingStep == 1) {
        return this.$t.onlineOrder.nextStep;
      }
      if (this.dialogBillingStep == 2) {
        if (this.content.LogisticsChannel) {
          return this.$t.onlineOrder.nextStep;
        } else {
          return this.$t.meta.confirm;
        }
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.meta.confirm;
      }
    },
    getDialogCancelText() {
      if (this.dialogBillingStep == 1) {
        return this.$t.meta.close;
      }
      if (this.dialogBillingStep == 2) {
        return this.$t.onlineOrder.prevStep;
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.onlineOrder.prevStep;
      }
    },
    getDialogTitle() {
      if (this.dialogBillingStep == 1) {
        return this.$t.onlineOrder.dialogBillingTitle1;
      }
      if (this.dialogBillingStep == 2) {
        return this.$t.onlineOrder.dialogBillingTitle2;
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.onlineOrder.dialogBillingTitle3;
      }
    },
    dialogSubmit() {
      if (this.dialogBillingStep == 1) {
        this.freightPriceCalculator().then((success) => {
          if (success) {
            this.dialogBillingStep = 2;
          }
        });
      } else if (this.dialogBillingStep == 2) {
        if (this.content.LogisticsChannel) {
          this.getDeclaredValue();
          this.getDeclaredValueCurrency();
          this.dialogBillingStep = 3;
        } else {
          this.onSubmit();
        }
      } else if (this.dialogBillingStep == 3) {
        this.onSubmit();
      }
    },
    dialogCancel() {
      if (this.dialogBillingStep == 1) {
        this.dialogBillingVisible = false;
      } else if (this.dialogBillingStep == 2) {
        this.dialogBillingStep = 1;
      } else if (this.dialogBillingStep == 3) {
        this.dialogBillingStep = 2;
      }
    },
    dialogBillingShow(items, orderList) {
      this.dialogBillingForm.items = [];
      this.dialogBillingForm.detailList = [];
      for (var order of orderList) {
        if (order.COId) {
          this.dialogBillingForm.items.push({
            COId: order.COId,
            ExpressNumber: order.ExpressNumber,
            CargoName: order.CargoName,
            ItemPrice: null,
            Currency: "",
            CustomsCode: "",
          });
          this.dialogBillingForm.detailList.push({
            COId: order.COId,
            ItemPrice: order.GoodsValue,
            Currency: order.Currency,
          });
        }
      }
      this.coidlist = items;
      this.dialogBillingVisible = true;
    },
    freightPriceCalculator() {
      return new Promise((resolve) => {
        var param = {
          FPId: this.FPId,
          FPDId: this.FPDId,
          Length: this.dialogBillingForm.Length,
          Width: this.dialogBillingForm.Width,
          Height: this.dialogBillingForm.Height,
          WeightKG: this.dialogBillingForm.WeightKG,
          DetailList: this.dialogBillingForm.detailList,
        };
        this.$commonMethod.showLoading();
        this.$api.calculator
          .freightPriceCalculator(param)
          .then((res) => {
            this.dialogBillingData = res.data;
            if (
              this.dialogBillingData[0] &&
              this.dialogBillingData[0].IsTaxFeebearingPartyInconsistent
            ) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: this.$t.onlineOrder.isTaxFeebearingPartyInconsistent,
              });
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    showCalculate(lists) {
      var messages = [];
      for (var list of lists) {
        if (list.CalculateStepsList) {
          for (var text of list.CalculateStepsList) {
            messages.push(text);
          }
        }
      }
      messages = messages.join("<br/><br/>");
      this.$commonMethod.customAlert2(
        {
          message: messages,
          showCancelButton: false,
          confirmButtonText: this.$t.alert.confirmButtonText,
        },
        () => {},
        () => {}
      );
    },
    getDeclaredValue() {
      let num = 0;
      this.dialogBillingForm.items.forEach(
        (item) => (num = Number(item["ItemPrice"]) + num)
      );
      this.dialogBillingForm["declaredValue"] = num.toFixed(3);
    },
    getDeclaredValueCurrency() {
      if (this.dialogBillingForm.items.length) {
        if (this.dialogBillingForm.items[0] && this.dialogBillingForm.items[0].Currency) {
          this.dialogBillingForm.declaredValueCurrency = this.dialogBillingForm.items[0].Currency.toUpperCase();
        } else {
          this.dialogBillingForm.declaredValueCurrency = "";
        }
      }
    },
    handleSelectionChange(product, parentIndex, childIndex) {
      let vue = this;
      vue.$forceUpdate();
      var coidlist = this.tableData[parentIndex].coidlist;
      if (product.Checked) {
        if (coidlist.find((id) => id == product.COId)) {
        } else {
          coidlist.push(product.COId);
        }
      } else {
        coidlist.splice(childIndex, 1);
      }
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      var pictureList = [];
      for (var image of images) {
        pictureList.push(this.imgUrlFilter(image));
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: pictureList,
        startPosition: 0,
      });
    },
    getCustomerOrderAlreadyInStorageListByTransportService() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          FPId: this.FPId,
          FPDId: this.FPDId,
        };
        this.$api.onlineOrderManagement
          .getCustomerOrderAlreadyInStorageListByTransportService(param)
          .then((res) => {
            if (res.data && res.data.cusList) {
              this.content = res.data;
              this.tableData = res.data.cusList;
              for (var index in this.tableData) {
                this.tableData[index].coidlist = [];
                for (var idx in this.tableData[index].cusOrderList) {
                  this.tableData[index].cusOrderList[idx].parentIndex = index;
                  //初始化数据
                  this.tableData[index].cusOrderList[idx].Checked = true;
                  this.tableData[index].coidlist.push(
                    this.tableData[index].cusOrderList[idx].COId
                  );
                }
              }
            } else {
              this.content = {};
              this.tableData = [];
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      var param = {
        COIdList: this.coidlist,
        FPId: this.FPId,
        FPDId: this.FPDId,
        Length: this.dialogBillingForm.Length,
        Width: this.dialogBillingForm.Width,
        Height: this.dialogBillingForm.Height,
        WeightKG: this.dialogBillingForm.WeightKG,
      };
      if (this.content.LogisticsChannel) {
        param.declaredValue = this.dialogBillingForm.declaredValue;
        param.declaredValueCurrency = this.dialogBillingForm.declaredValueCurrency;
        param.Naqel_ShippingDateTime = this.dialogBillingForm.Naqel_ShippingDateTime;
        param.Naqel_DescriptionOfGoods = this.dialogBillingForm.Naqel_DescriptionOfGoods;
        param.Naqel_NumberOfPieces = this.dialogBillingForm.Naqel_NumberOfPieces;
        param.iMile_PackageTotalVolume = this.dialogBillingForm.iMile_PackageTotalVolume;
        param.iMile_PackageGrossWeight = this.dialogBillingForm.iMile_PackageGrossWeight;
        param.iMile_PackageTotalCount = this.dialogBillingForm.iMile_PackageTotalCount;
        param.iMile_PackageGoodsType = this.dialogBillingForm.iMile_PackageGoodsType;
        param.DetailList = this.dialogBillingForm.items;
        param.DeliveryZipCode = this.dialogBillingForm.deliveryZipCode;
      }
      this.$commonMethod.showLoading();
      this.$api.onlineOrderManagement
        .addExpressWaybillByCOIdList(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getCustomerOrderAlreadyInStorageListByTransportService();
          this.dialogBillingVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    showDialogTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showDialogTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour = value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10 ? "0" + value.getMinutes() : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      this.dialogBillingForm.Naqel_ShippingDateTime = formatDate(date);
      this.showDialogTimePicker = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.hasBeenStoredDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1890ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
      }
    }
  }
  .list-container {
    color: #333;
    padding: 10px;
    margin-top: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .list-header {
      font-size: 12px;
      border-bottom: 1px solid #ebedf0;
      .list-header-text {
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 10px;
      }
    }
    .list-content {
      padding: 10px;
      font-size: 10px;
      .van-checkbox {
        text-align: center;
        vertical-align: top;
        display: inline-block;
        width: 10%;
      }
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 60%;
        .list-item {
          margin-bottom: 5px;
          .van-icon-success {
            color: #01aaa3;
            font-size: 14px;
          }
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 30%;
        .images {
          overflow: hidden;
          vertical-align: middle;
          text-align: center;
          ::v-deep img {
            border-radius: 8px;
          }
        }
      }
    }
    .list-footer {
      border-top: 1px solid #ebedf0;
      text-align: center;
      .primary-btn {
        margin-left: 5px;
        margin-top: 10px;
        border-radius: 5px;
        background: $-color-primary;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .billing-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 1px solid #ebedf0;
    position: relative;
    .dialog-container {
      .dialog-table {
        font-size: 12px;
        color: #333;
        border-bottom: 1px solid #ebedf0;
        .dialog-item {
          margin-bottom: 10px;
        }
        .dialog-item:last-child {
          margin-bottom: 0px !important;
        }
      }
      .dialog-table-footer {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
        .primary-btn {
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
    .custom-date {
      background: #ffffff;
      padding: 12px 16px;
      border-bottom: 1px solid #ebedf0;
      .date-btn1 {
        width: 120px;
        display: inline-block;
        margin-right: 12px;
        font-size: 14px;
        color: #646566;
        vertical-align: middle;
        .date-require {
          color: red;
          position: absolute;
          left: 8px;
        }
      }
      .date-btn2 {
        width: 50%;
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
        .value {
          color: #323233;
        }
        .placeholder {
          color: #c3c3c3;
        }
      }
    }
    .custom-field {
      font-size: 14px;
      padding: 12px 16px;
      border-bottom: 1px solid #ebedf0;
      .custom-field-label {
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
    }
    ::v-deep .van-field--disabled {
      .van-field__label,
      .van-field__control {
        color: #999 !important;
        -webkit-text-fill-color: #999 !important;
      }
    }
  }
  .dialog-item-row {
    margin-bottom: 10px;
    .van-col {
      text-align: left;
      font-size: 12px;
    }
  }
  .empty-text {
    text-align: center;
    padding: 50px;
    font-size: 14px;
    color: #969799;
  }
}
</style>
